module.exports = __webpack_public_path__ + "static/mr-press-07-67f326f615dbe3b1397b040e440047c2.jpg";